<template>
  <div>
    <md-card id="reports" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">attach_money</i>
        </div>
        <h4 class="title">Billing</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="currentSearchTxt" @keyup.enter="handleSearch" />
            </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Date</label>
              <md-select v-model="currentFilterDate" name="currentFilterDate">
                <md-option v-for="(type, index) in filterDateOptions" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Status</label>
              <md-select v-model="currentFilterStatus" name="currentFilterStatus">
                <md-option v-for="(type, index) in filterStatusOptions" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div v-if="organizations.length > 2" class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item" :class="[
            { 'md-size-35': organizations.length > 2 },
            { 'md-size-50': organizations.length <= 2 }
          ]" style="align-items: end">
            <div class="md-layout md-gutter md-layout-item"
              style="display: flex; align-items: center; justify-content: right">
              <md-button class="md-icon-button md-primary" @click="handleSearch">
                <md-icon>search</md-icon>
                <md-tooltip md-direction="bottom">Filter claims</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <md-table v-if="!isLoading" id="reports-table" v-model="tableData"
          class="table-shopping table-striped table-hover">
          <md-table-row>
            <md-table-empty-state :md-description="`No claims found for this time frame or search criteria`"
              md-label="No claims found" />
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell />
            <md-table-cell md-label="Report Date" style="font-size: 0.88em; font-weight: 500">
              <span>{{ formattedDate(item) }}</span> <br />
              <small style="font-size: 0.87em; color: darkgreen">
                {{ item.screening && item.screening.packageId ? item.screening.packageId.slice(0, 11).toUpperCase() :
                  '-' }}</small>
            </md-table-cell>

            <md-table-cell md-label="Claim Number">
              {{ item.claimNumber || '-' }}
            </md-table-cell>

            <md-table-cell md-label="Patient Name">
              {{ item.person && item.person.firstName || '-' }} {{ item.person && item.person.lastName || '' }}
            </md-table-cell>
            <md-table-cell md-label="Patient Email">
              {{ item.person && item.person.email || '-' }}
            </md-table-cell>
            <md-table-cell md-label="Status">
              <div v-if="!item.status"
                style="display:flex;align-items: center; justify-content: center; height:22px; border-radius: 11px;background-color: gray;color: white;min-width: 90px;max-width: 90px; font-size: 80%;">
                Not Submitted
              </div>
              <div v-else-if="item.status === 'Submitted'"
                style="display:flex;align-items: center; justify-content: center; height:22px; border-radius: 11px;background-color: orange;color: white;min-width: 90px;max-width: 90px; font-size: 80%;">
                Submitted
              </div>
              <div v-else-if="item.status === 'Paid'"
                style="display:flex;align-items: center; justify-content: center; height:22px; border-radius: 11px;background-color: #009d00;color: white;min-width: 90px;max-width: 90px; font-size: 80%;">
                Paid
              </div>
              <div v-else-if="item.status === 'Rejected'"
                style="display:flex;align-items: center; justify-content: center; height:22px; border-radius: 11px;background-color: darkred;color: white;min-width: 90px;max-width: 90px; font-size: 80%;">
                Rejected
              </div>
              <div v-else-if="item.status === 'Accepted'"
                style="display:flex;align-items: center; justify-content: center; height:22px; border-radius: 11px;background-color: #009d00;color: white;min-width: 90px;max-width: 90px; font-size: 80%;">
                Accepted
              </div>
              <small v-else>{{ item.status }}</small>
            </md-table-cell>
            <md-table-cell md-label="Total Amount">
              {{ item.totalClaimAmount ? '$' + item.totalClaimAmount.toFixed(2) : '-' }}
            </md-table-cell>
            <md-table-cell>
              <div style="display: flex; justify-content: space-between">
                <button :disabled="!!item.status"
                  :style="!!item.status ? 'opacity: 0.5; width: 35px; height: 27px; margin: 0px 0px 0px 5px;background-color: rgb(18, 180, 235);box-shadow: 0 2px 2px 0 rgba(18, 180, 235,.14),0 3px 1px -2px rgba(18, 180, 235,.2),0 1px 5px 0 rgba(18, 180, 235,.12);border-radius: 3px;' : 'width: 35px; height: 27px; margin: 0px 0px 0px 5px;background-color: rgb(18, 180, 235);box-shadow: 0 2px 2px 0 rgba(18, 180, 235,.14),0 3px 1px -2px rgba(18, 180, 235,.2),0 1px 5px 0 rgba(18, 180, 235,.12);border-radius: 3px;'"
                  @click.stop="handleEnsoraClick(item)">
                  <!-- <img style="width: 25px;" src="https://developers.apexedi.com/images/EnsoraLogo_Icon.png"> -->
                  <svg style="width: 23px;" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 62.05 72">
                    <path class="cls-1" style="fill: #fff;"
                      d="M50.63,33.08v21.99h-11.1v-27.03H11.42v-11.1h23.07c8.9,0,16.14,7.24,16.14,16.14Z" />
                    <path class="cls-1" style="fill: #fff;"
                      d="M35.76,47.95v7.12h-11.11v-12.15h-13.23v-11.1h8.19c8.9,0,16.14,7.24,16.14,16.14Z" />
                    <path class="cls-1" style="fill: #fff;"
                      d="M20.59,54.53v.53h-9.14v-8.22h1.45c4.25,0,7.69,3.44,7.69,7.69Z" />
                  </svg>
                  <md-tooltip md-direction="bottom">{{ !!item.status ? 'Claim already submitted' :
                    'Submit claim to Ensora' }}</md-tooltip>
                </button>
              </div>
            </md-table-cell>

            <md-table-cell />
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading" />
        <div v-if="!isLoading" style="display: flex; align-items: center">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span class="page-link"
              style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px">{{ currentPage
              }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b><u>{{ startReport }}</u></b>
                to
                <b><u>{{ endReport }}</u></b>. Total of
                <b><u>{{ totalReports }}</u></b>
                reports.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>

    <loader :is-visible="isLoading || sendingToEnsora" />
  </div>
</template>

<script>
import Swal from "sweetalert2"
import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"
import InfoRxPrescription from "@/components/GlobeChek/screening/info-rx-prescription"
import { Modal } from "@/components"
import RxReportPreview from "@/components/GlobeChek/screening/eval-rxreport-preview"
import { mapActions } from "vuex"

export default {
  components: {
    loader,
    "prescription-info": InfoRxPrescription,
    "rx-report-preview": RxReportPreview,
    Modal
  },
  data() {
    return {
      sendingToEnsora: false,
      API_SERVICE: process.env.VUE_APP_URL,
      API_ROUTE: "/clearinghouse/ensora/claims",
      allReports: [],
      filteredReports: [],
      tableData: [],
      reportsSelected: [],
      allSelected: false,
      currentSort: "name",
      currentSortOrder: "asc",
      orderAsc: false,
      searchQuery: "",
      fuseSearch: null,
      offset: 0,
      limit: 50,
      totalReports: 0,
      pagination: {
        perPage: 50,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      isLoading: false,
      isDownloading: false,
      downloadProgress: 0,
      filterStatusOptions: [
        {
          label: "All",
          value: "all"
        },
        {
          label: "Not Submitted",
          value: "notSubmitted"
        },
        {
          label: "Submitted",
          value: "submitted"
        },
        {
          label: "Paid",
          value: "paid"
        },
        {
          label: "Rejected",
          value: "rejected"
        },
        {
          label: "Accepted",
          value: "accepted"
        }
      ],
      filterDateOptions: [
        {
          label: "All",
          value: "all"
        },
        {
          label: "Past day",
          value: "pastDay"
        },
        {
          label: "Past week",
          value: "pastWeek"
        },
        {
          label: "Past month",
          value: "pastMonth"
        },
        {
          label: "Past 3 months",
          value: "past3Months"
        },
        {
          label: "Past 6 months",
          value: "past6Months"
        },
        {
          label: "Past year",
          value: "pastYear"
        }
      ],
      currentOrganization: 'all',
      organizations: [
        { label: "All", value: "all" },
        ...JSON.parse(sessionStorage.getItem("organizations")).map((i) => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        })
      ],
      currentSearchTxt: "",
      currentFilterDate: "all",
      currentFilterDownloaded: "all",
      currentFilterStatus: "all"
    }
  },
  computed: {
    // Returns a page from the searched data or the whole data. Search is performed in the watch section below
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.filteredReports.length
    },
    startReport() {
      return this.offset + 1
    },
    endReport() {
      return Math.min(this.offset + this.limit, this.filteredReports.length) || 1
    },
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.sliceReports()
    }
  },

  methods: {
    async handleEnsoraClick(item) {
      try {
        this.sendingToEnsora = true
        const images = await window.axios.get(`${process.env.VUE_APP_URL}/images/${item.screening.packageId}`).then(res => res.data)
        await window.axios.post(`${process.env.VUE_APP_URL}/clearinghouse/ensora/claims`, { screeningId: item.screening.packageId, images })
        Swal.fire({
          title: "Success",
          text: "Data was submitted to Ensora's platform successfully",
          icon: "success",
          confirmButtonText: "OK"
        })
        this.fetchReports()
      } catch (error) {
        if (error && error.response && error.response.data && error.response.data.detail && error.response.data.detail.message) {
          Swal.fire({
            title: "Error",
            text: "An error occurred while sending data to Ensora's Platform: \n" + error.response.data.detail.message,
            confirmButtonText: "OK"
          })
        } else {
          Swal.fire({
            title: "Error",
            text: "An error occurred while sending data to Ensora's Platform. Try again later",
            confirmButtonText: "OK"
          })
        }
      } finally {
        this.sendingToEnsora = false
      }
    },
    setReadingDoctor() {
      let fn = sessionStorage.getItem("firstname")
      let ln = sessionStorage.getItem("lastname")
      let readingDoctor = fn + " " + ln + " " + "MD"
      sessionStorage.setItem("ReadingDoctor", readingDoctor)
    },
    async fetchReports() {
      this.isLoading = true
      const url = this.API_SERVICE + this.API_ROUTE
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null

      window.axios
        .get(url, data, config)
        .then((r) => r.data)
        .then((reports) => {
          // remove duplicated reports
          const reportMap = new Map()
          reports.forEach((report) => {
            const packageId = report.screening && report.screening.packageId ? report.screening.packageId : String(new Date().getTime()) + String(Math.random());
            const updatedAt = report.screening && report.screening.reportCreatedAt ? report.screening.reportCreatedAt : report.statusChangedAt;
            if (!reportMap.has(packageId) || new Date(updatedAt) > new Date(reportMap.get(packageId) && reportMap.get(packageId).screening && reportMap.get(packageId).screening.reportCreatedAt || 0)) {
              reportMap.set(packageId, report)
            }
          })
          this.allReports = Array.from(reportMap.values())
          this.handleSearch()
        })
        .catch(function (error) {
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    sliceReports() {
      this.tableData = JSON.parse(JSON.stringify(this.filteredReports)).slice(this.offset, this.offset + this.limit)
    },
    updateLimit(newLimit) {
      this.offset = 0
      this.sliceReports()
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.sliceReports()
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.sliceReports()
      }
    },
    itemRead(item) {
      return item.status == "read"
    },
    formattedDate(item) {
      if (item.screening && item.screening.reportCreatedAt)
        return new moment(item.screening.reportCreatedAt).format("MM/DD/YYYY")
      return '-'
    },
    handleSearch() {
      this.reportsSelected = []
      this.allSelected = []
      const searchFilter = this.currentSearchTxt
      const dateFilter = this.currentFilterDate
      const orgFilter = this.currentOrganization
      const statusFilter = this.currentFilterStatus

      let response = JSON.parse(JSON.stringify(this.allReports))
      if (searchFilter) {
        response = response.filter((i) => {
          const searchText = (
            (i.person && i.person.firstName || "") +
            " " +
            (i.person && i.person.lastName || "") +
            (i.person && i.person.email || "") + (i.claimNumber)
          ).toLowerCase()
          return searchText.includes(searchFilter.toLowerCase())
        })
      }
      if (orgFilter != "all") {
        response = response.filter((i) => (i.screening && i.screening.orgId === orgFilter) || false)
      }
      if (dateFilter != "all") {
        const filters = {
          pastDay: moment(new Date()).subtract(1, "day").toDate().toISOString(),
          pastWeek: moment(new Date()).subtract(7, "days").toDate().toISOString(),
          pastMonth: moment(new Date()).subtract(1, "month").toDate().toISOString(),
          past3Months: moment(new Date()).subtract(3, "months").toDate().toISOString(),
          past6Months: moment(new Date()).subtract(6, "months").toDate().toISOString(),
          pastYear: moment(new Date()).subtract(1, "year").toDate().toISOString()
        }
        response = response.filter((i) => i.screening && i.screening.reportCreatedAt ? i.screening.reportCreatedAt >= filters[dateFilter] : i.statusChangedAt >= filters[dateFilter])
      }
      if (statusFilter != "all") {
        if (statusFilter === "notSubmitted") {
          response = response.filter((i) => !i.status)
        } else if (statusFilter === "submitted") {
          response = response.filter((i) => i.status === "Submitted")
        } else if (statusFilter === "paid") {
          response = response.filter((i) => i.status === "Paid")
        } else if (statusFilter === "rejected") {
          response = response.filter((i) => i.status === "Rejected")
        } else if (statusFilter === "accepted") {
          response = response.filter((i) => i.status === "Accepted")
        }
      }
      this.filteredReports = response
      this.totalReports = response.length
      this.offset = 0
      this.sliceReports()
    },
  },
  mounted() {
    this.fetchReports()
  }
}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  font-size: 0.85rem;
  height: 38px;
}

.md-table-row {
  color: rgb(0, 6, 97);
}

.md-table-row:hover {
  background-color: #0077ff !important;
  color: white;
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.md-table-row.md-selected-single {
  font-weight: 400;
  font-size: 0.95rem;
  color: white;
  background-color: #00418b !important;
}

// .md-icon {
//   margin-left: 24px !important;
// }

#headers {
  transition: none;
  background-color: #edf2f7 !important;
}

.dropdown-menu {
  li {
    padding: 3px 3px 3px 5px;
  }

  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}

.isRead {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
}

.isEDIT {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
  background-color: #e6ffe6 !important;
}

.md-table-row.isEDIT:hover {
  background-color: #ccffcc !important;
  color: #000000 !important;
}

.md-button.md-grey {
  background-color: #d3d3d3 !important;
  color: #808080 !important;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-container span {
  margin: 0 15px;
}
</style>
